import {defineMessages, FormattedMessage} from 'react-intl';
import {Text, Overlay} from 'src/v2/components/common';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {useSelector} from 'src/v2/state/store';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';

const messages = defineMessages({
  approvePermit: {
    id: 'crypto.payins.v2.setup_confirmation_pending.approve_permit',
    description:
      'Prompt to tell the user to approve the spending cap request in their crypto wallet',
    defaultMessage:
      'To save this payment method, allow {businessName} to withdraw funds from your wallet for future purchases.',
  },
});

export const SetupConfirmationPendingOverlay = () => {
  const businessName = useSelector(
    (state) => state.merchantBranding.businessName,
  );
  const activeWallet = useSelector(
    (state) => state.walletConnection.activeWallet,
  );

  if (!activeWallet) {
    throw new Error(
      'activeWallet is required in SetupConfirmationPendingOverlay',
    );
  }

  const walletOption = WalletRegistry.getWalletOption({
    provider: activeWallet.type,
    key: activeWallet.key,
  });

  if (!walletOption) {
    throw new Error(
      'Wallet option not found in SetupConfirmationPendingOverlay',
    );
  }

  return (
    <Overlay name="setup-confirmation-pending">
      <WalletIcon walletOption={walletOption} />
      <Text type="title" css={{textColor: 'inherit'}}>
        <FormattedMessage {...messages.approvePermit} values={{businessName}} />
      </Text>
    </Overlay>
  );
};
